import { jsx as _jsx } from "react/jsx-runtime";
const LOOK = {
    color: "var(--accent)",
    fontWeight: "var(--type-body-weight-strong)",
    textDecorationLine: "underline",
    textDecorationColor: "var(--link-underline, var(--accent-line))",
    textDecorationThickness: "var(--border-hairline)",
    textUnderlineOffset: "var(--space-05)",
    borderRadius: "var(--radius-focus)",
};
export function TextLink(props) {
    if (props.href === undefined) {
        const { href: _href, children, onClick, disabled = false, ...hooks } = props;
        return (_jsx("button", { type: "button", "data-link": "", ...hooks, onClick: onClick, disabled: disabled, style: {
                ...LOOK, padding: 0, border: "none", background: "transparent",
                cursor: disabled ? "default" : "pointer", font: "inherit", fontWeight: LOOK.fontWeight,
                ...(disabled ? { color: "var(--ink-2)", textDecorationColor: "var(--line)" } : {}),
            }, children: children }));
    }
    const { href, children, onNavigate, newTab = false, ...hooks } = props;
    return (_jsx("a", { href: href, "data-link": "", ...hooks, target: newTab ? "_blank" : undefined, rel: newTab ? "noopener noreferrer" : undefined, onClick: (event) => {
            if (onNavigate === undefined)
                return;
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
                return;
            event.preventDefault();
            onNavigate();
        }, style: LOOK, children: children }));
}
